module.exports = __webpack_public_path__ + "media/product/t-3-6159d8a3.png";